var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DDDD3"
    },
    d: "M256,0c141.385,0,256,114.615,256,256S397.385,512,256,512S0,397.385,0,256S114.615,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M148.764,228.579H249.07v8.735H148.764V228.579z M148.764,275.311L148.764,275.311H249.07v8.74 H148.764V275.311z M148.764,251.942L148.764,251.942H249.07v8.74H148.764V251.942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20D0C2"
    },
    d: "M148.764,125.29H249.07v8.74H148.764V125.29z M148.764,172.022L148.764,172.022H249.07v8.74H148.764 V172.022z M148.764,148.656L148.764,148.656H249.07v8.74H148.764V148.656z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M157.121,435.925h83.593v-8.74h-83.59v8.74H157.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M157.121,76.075h83.593v8.74h-83.593V76.075z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20D0C2"
    },
    d: "M148.764,332.429H249.07v8.74H148.764V332.429z M148.764,379.161L148.764,379.161H249.07v8.742 H148.764V379.161z M148.764,355.795L148.764,355.795H249.07v8.74H148.764V355.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M193.554,299.009c22.526,4.239,37.433,12.158,47.177,21.197c23.326,21.637,23.326,58.281,0,79.915 c-9.747,9.036-24.651,16.958-47.177,21.194c-18.985,3.573-29.511,12.396-35.35,21.131h-21.005 c6.23-15.001,20.452-33.323,52.927-39.434c18.61-3.499,30.482-9.634,37.918-16.528c15.313-14.206,15.313-38.435,0-52.644 c-7.436-6.893-19.305-13.026-37.918-16.525c-77.295-14.545-76.526-108.233,0-122.631c18.61-3.502,30.482-9.634,37.918-16.525 c15.313-14.209,15.313-38.438,0-52.644c-7.436-6.893-19.305-13.028-37.918-16.528c-34.763-6.542-48.61-27.077-54.128-42.55h20.305 c5.343,9.666,15.998,20.247,37.252,24.244c22.526,4.236,37.428,12.158,47.177,21.196c23.326,21.637,23.326,58.281,0,79.915 c-9.747,9.039-24.651,16.958-47.177,21.197c-56.502,10.628-56.502,75.393,0,86.021V299.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A91A1"
    },
    d: "M198.937,299.009c-22.526,4.239-37.43,12.158-47.177,21.197c-23.326,21.637-23.326,58.281,0,79.915 c9.747,9.036,24.651,16.958,47.177,21.194c18.983,3.573,29.509,12.396,35.348,21.131h21.005 c-6.23-15.001-20.452-33.32-52.927-39.434c-18.61-3.499-30.479-9.634-37.916-16.528c-15.316-14.206-15.316-38.435,0-52.644 c7.434-6.893,19.305-13.026,37.916-16.525c76.82-14.455,76.437-108.249,0-122.631c-18.61-3.502-30.479-9.634-37.916-16.525 c-15.316-14.209-15.316-38.438,0-52.644c7.434-6.893,19.305-13.028,37.916-16.528c34.763-6.544,48.612-27.077,54.131-42.55h-20.307 c-5.34,9.666-15.998,20.247-37.249,24.244c-22.526,4.236-37.43,12.158-47.177,21.196c-23.326,21.637-23.326,58.281,0,79.915 c9.747,9.039,24.651,16.958,47.177,21.197c56.5,10.628,56.5,75.393,0,86.021V299.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M255.583,156.659c54.084-14.148,109.398,18.227,123.546,72.308 c8.74,33.414-0.281,67.288-21.199,91.643l47.188,46.566l-9.805,9.666l-47.041-46.422c-11.518,10.209-25.548,17.931-41.454,22.091 c-54.084,14.148-109.4-18.225-123.546-72.308c-14.148-54.084,18.225-109.398,72.308-123.546L255.583,156.659z M258.568,168.069 L258.568,168.069c-47.783,12.501-76.385,61.37-63.886,109.151c12.501,47.783,61.37,76.384,109.154,63.886 c47.781-12.501,76.385-61.37,63.883-109.151c-12.499-47.783-61.368-76.385-109.148-63.886H258.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20D0C2"
    },
    d: "M258.571,168.066c47.783-12.499,96.65,16.103,109.148,63.886 c12.501,47.783-16.103,96.65-63.883,109.151c-47.783,12.499-96.652-16.103-109.151-63.883 C182.186,229.437,210.787,180.568,258.571,168.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DDDD3"
    },
    d: "M276.276,343.897c-26.526-11.465-47.697-34.571-55.576-64.694 c-12.333-47.138,12.126-95.244,55.563-113.925c41.611-2.345,80.5,24.801,91.454,66.674c12.501,47.783-16.103,96.65-63.883,109.151 c-9.236,2.416-18.513,3.289-27.56,2.793H276.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB429"
    },
    d: "M353.222,343.939l21.301-21c3.195-3.153,8.38-3.111,11.531,0.081l101.61,102.798 c3.153,3.192,3.114,8.383-0.081,11.536l-21.301,21c-3.192,3.148-8.378,3.108-11.531-0.081L353.14,355.472 c-3.148-3.187-3.111-8.378,0.087-11.531L353.222,343.939z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M201.84,213.368h90.103v13.585h-95.805C197.664,222.266,199.577,217.723,201.84,213.368z  M203.91,299.602L203.91,299.602c-2.492-4.283-4.656-8.819-6.437-13.585h94.47v13.585H203.91z M192.188,263.279L192.188,263.279 c-0.449-4.564-0.543-9.102-0.299-13.585h100.055v13.585H192.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M232.886,329.832c9.823,3.281,18.377,7.108,25.81,11.313 C249.521,338.751,240.81,334.916,232.886,329.832z M265.826,166.487L265.826,166.487c-10.521,6.977-23.667,13.149-40.045,17.892 c9.401-7.431,20.457-13.089,32.79-16.315C260.986,167.434,263.407,166.912,265.826,166.487z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A91A1"
    },
    d: "M254.201,339.847c73.927-36.872,72.447-134.363-3.51-169.323 c-12.11,4.38-22.781,11.182-31.594,19.704c80.219,18.807,81.03,110.686,2.418,130.959 C230.961,329.633,242.116,336.007,254.201,339.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M258.571,168.066c5.907-1.545,11.83-2.458,17.697-2.788c-1.033,0.443-2.056,0.91-3.069,1.388 c-2.083,0.388-4.165,0.858-6.245,1.401c-47.783,12.501-76.385,61.37-63.889,109.151c9.055,34.611,37.192,59.149,70.173,65.3 c1.005,0.477,2.017,0.939,3.037,1.38c-37.756-2.072-71.508-28.134-81.594-66.679c-12.499-47.781,16.103-96.65,63.886-109.151 H258.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.146,173.305c-5.43-1.435-10.878-2.282-16.273-2.589c0.952,0.414,1.889,0.847,2.82,1.291 c1.915,0.362,3.832,0.795,5.744,1.301c2.468,0.653,4.876,1.416,7.232,2.274c40.434,14.424,63.773,57.171,52.68,99.021 c-7.3,27.542-27.796,48.211-53.04,57.145c-4.102,1.482-8.331,2.641-12.651,3.454c-0.926,0.443-1.854,0.873-2.796,1.28 c34.723-1.925,65.767-26.109,75.039-61.879c11.497-44.339-14.809-89.694-58.755-101.295V173.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5A209"
    },
    d: "M438.789,435.233l-86.507-87.519c-0.325-0.33-0.619-0.682-0.884-1.049 c-1.188,2.93-0.614,6.424,1.736,8.805l82.229,83.191l19.384,19.61c2.442,2.473,6.109,3.053,9.12,1.723 c-0.797-0.412-1.545-0.952-2.209-1.626L438.789,435.233z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDna);
export default __webpack_public_path__ + "static/media/dna.ca30856f093ef52aede93bfaab31700a.svg";
export { ForwardRef as ReactComponent };